/**
 * HeaderMenuButton.tsx — hamburger-knapp for å toggle side-nav
 *
 * Ren React-komponent som erstatter cds-header-menu-button.
 * Viser MenuIcon, toggler side-nav ved klikk.
 *
 * Props:
 * - active: om side-nav er utvidet (styling)
 * - onClick: klikk-handler
 * - label: aria-label for tilgjengelighet
 */

import { MenuIcon } from '@/components/icons';
import styles from './header-menu-button.module.css';

interface HeaderMenuButtonProps {
  active?: boolean;
  onClick?: () => void;
  label?: string;
}

export default function HeaderMenuButton({
  active = false,
  onClick,
  label = 'Åpne meny',
}: HeaderMenuButtonProps) {
  return (
    <button
      type="button"
      className={styles.menuButton}
      aria-label={label}
      aria-expanded={active}
      onClick={onClick}
    >
      <MenuIcon size={20} />
    </button>
  );
}
